module.exports = __webpack_public_path__ + "static/media/BrokerGenericTemplateHTMLUserGuide.13cae983.docx";